import { useApi } from '~/api';
import { components } from '~~/api-types';

export type BusinessOnboarding =
  components['schemas']['BusinessOnboardingResponseDto'];

export const apiStartOnboarding = async (): Promise<void> => {
  const api = useApi();

  await api(`/app/onboardings/start`, {
    method: 'POST',
  });
};

export const apiDismissOnboardingBannerOnboarding = async (): Promise<void> => {
  const api = useApi();

  await api(`/app/onboardings/dismiss-banner`, {
    method: 'POST',
  });
};

export const apiSubmitOnboardingStepData = async (
  body: components['schemas']['SubmitOnboardingStepDataBody'],
): Promise<void> => {
  const api = useApi();

  await api(`/app/onboardings/step-data`, {
    method: 'PUT',
    body,
  });
};
